import dynamic from "next/dynamic";

export const DynamicHero001 = dynamic(() => import("./Hero001"), {
  suspense: true,
});
